import Mention from '@tiptap/extension-mention'

export const CustomMention = Mention.extend({
  // Define additional attributes for the custom mention
  addAttributes() {
    return {
      id: {
        default: null,
        // Parse the user ID and label from the HTML element
        parseHTML: (element) => {
          return {
            id: element.getAttribute('user-id'),
            label: element.textContent?.slice(1), // Remove the leading '@' character
          }
        },
        // Render the user ID attribute in the HTML output
        renderHTML: (attributes) => {
          if (!attributes.id) {
            return {}
          }
          return {
            'user-id': attributes.id.id,
          }
        },
      },
    }
  },

  // Define commands for inserting mentions
  addCommands() {
    return {
      setMention:
        attributes =>
          ({ chain }) => {
            const mention = this.type
            const { commands } = chain()
            // Insert the mention content with the specified attributes
            return commands.insertContent({
              type: mention.name,
              attrs: attributes,
            })
          },
    }
  },

  // Render the mention in the HTML output
  renderHTML(input) {
    const { id } = input.node.attrs
    const displayText = id.label
    // Wrap the mention in a <span> element with the 'mention' class and 'user-id' attribute
    // The '@' character is prepended to the display text
    return ['span', { 'class': 'mention', 'user-id': id.id }, `@${displayText}`]
  },

  // Parse the mention from the HTML input
  parseHTML() {
    return [
      {
        // Match <span> elements with the 'mention' class and 'user-id' attribute
        tag: 'span[user-id].mention',
        // Extract the user ID and label from the matched element
        getAttrs: dom => ({
          id: dom.getAttribute('user-id'),
          label: dom.textContent?.slice(1), // Remove the leading '@' character
        }),
        // Set a higher priority to ensure this rule is applied before others
        priority: 51,
      },
    ]
  },
})
